var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8856 7.11279L13.232 12.0729C13.142 12.3429 12.9903 12.5883 12.7891 12.7895C12.5878 12.9908 12.3424 13.1425 12.0724 13.2325L7.1123 14.8861L8.76597 9.92604C8.85597 9.65601 9.00761 9.41064 9.20888 9.20937C9.41015 9.0081 9.65552 8.85646 9.92555 8.76646L14.8856 7.11279Z",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 20.1663C16.0623 20.1663 20.1663 16.0623 20.1663 10.9997C20.1663 5.93706 16.0623 1.83301 10.9997 1.83301C5.93706 1.83301 1.83301 5.93706 1.83301 10.9997C1.83301 16.0623 5.93706 20.1663 10.9997 20.1663Z",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.7c78990c0654d8c2201b220c029bbca0.svg";
export { ForwardRef as ReactComponent };